import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { YoyakuService } from "../service/yoyaku.service";
import { SOUND_CODE } from './note_sound';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminshareService } from "../service/adminshare.service";
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';
import { a } from '@angular/core/src/render3';


@Component({
    selector: 'yoyaku-accept-list-app',
    templateUrl: './yoyaku-accept-list.component.html',
    styleUrls: ['yoyaku-accept-list.component.css']
})
export class YoyakuAcceptListComponent implements OnInit {
    title: string = '予約受付一覧';
    isLoaded: boolean = false;
    datalist: any = [];
    all_datalist: any = [];
    ROLE: any = Role;
    page: number = 1;
    all_count: number = 0;
    display_per_page: number = 20;   /* 最大表示件数 */
    selectid: any = 0;
    mode: number;
    id: any;
    timeOutLimit: number =null;
    reloadFlg: boolean;
    soundFlg: boolean;
    dupFlg: boolean = false;
    setTime:number = 30;
    base64:any;
    sound:any;
    timeOutId: any;
    compare_data: any =[];
    date:any;
    acceptlist:any=[];
    accceptSetting:any = { }
    divisionID:string =null;
    tmp_datalist:any=[];
    selectedList: any = [];
     
    countDownSeconds:any = [
        { id: 0, name: "30秒", second: 30000 },
        { id: 1, name: "45秒", second: 45000 },
        { id: 2, name: "1分", second: 60000 },
        { id: 3, name: "1分30秒", second: 90000 },
        { id: 4, name: "2分", second: 120000 },
        { id: 5, name: "5分", second: 300000 },
        { id: 6, name: "10分", second: 600000 },
    ];
    secondId: number = 0;

    constructor(
        private commonService: CommonService,
        private yoyakuService: YoyakuService,
        public usersService: UsersService,
        private adminShareService: AdminshareService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }
    ngOnInit(): void {
        this.getList();
        this.selectid = 0;
        this.timeOutLimit=30000;  
        this.date = this.currentDate();
        this.accceptSetting = this.adminShareService.getaccceptSetting();
    }
    currentDate():string{
        var today = new Date();
        var year = today.getFullYear();
        var month = today.getMonth() + 1;
        var day = today.getDate();
        var date = year + '/' + month + '/' + day + '';

        return date;
    }
     clearData(): void {
        this.isLoaded = false;
        this.datalist = [];
        this.all_datalist = [];
        this.tmp_datalist = [];
    }
    getList(): void {
        this.clearData();
        this.currentDate();
        this.yoyakuService.getYoyakuAcceptList()
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    // this.all_datalist = res["fuel_results"]['yoyaku_accept_list'];
                    this.all_datalist = res["fuel_results"]['yoyaku_accept_list']['division'];
                    if (this.all_datalist.length > 0) {
                        this.page = 1;
                        if(this.divisionID==null){
                            //区分の指定がないときは区分の中の最初の区分を指定
                            this.divisionID = this.all_datalist[0]["division_id"];
                            this.changePage(1);
                        }

                        this.select_division_button(this.selectid);
                        this.dupFlg = this.listCheckid();
                        if(this.dupFlg && this.accceptSetting.soundFlg){
                            this.note_sound();
                        }
                    }
                    this.isLoaded = true;
                } else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                } else {
                    this.commonService.modalOpens(11003, modalresult => { });
                }
            }, error => {
                this.commonService.modalOpens(error, modalresult => { });
            });
    }
    
    select_division_button(i){
        this.selectid=i;
        this.all_count = this.all_datalist[i]["acceptlist"].length;
        this.page = 1;
        this.changePage(1);
    }

    
    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist[this.selectid]["acceptlist"].slice(start, start+this.display_per_page);
    }

    reload(a): void {
        if(a==1){
            if(this.accceptSetting.reloadFlg===true){
                this.compare_data = this.acceptlist;
                this.getList();
                this.changeTimeOut();
            } else {
                //
            }
        }else{
            this.compare_data = this.acceptlist;
            this.getList();
            this.changeTimeOut();
        }
        
    };
    
    //指定秒数で自動リロード設定
    changeTimeOut(): void {
        this.adminShareService.setaccceptSetting(this.accceptSetting);
        if(this.accceptSetting.reloadFlg===true){
            this.timeOutId = setTimeout(() => {
                if (this.router.url =="/yoyaku-accept-list")
                {
                    this.reload(1);
                }
            }, this.timeOutLimit);
        } else {
            clearTimeout(this.timeOutId);
            delete this.timeOutId;
        }
    };
    //セレクトボックスから指定秒数決定
    changeSelect(id:number):void{
        this.adminShareService.setaccceptSetting(this.accceptSetting);
        var select = [];
        select = this.countDownSeconds.filter(item=> item.id==id);
        clearTimeout(this.timeOutId);
        this.timeOutLimit = select[0].second;
        this.changeTimeOut();
    }
    //リストデータの増減で音を鳴らすための比較データ取得
    listCheckid(): boolean {
        var checkidA = [];
        var checkidB = [];
        var aCount: number = 0;
        if(this.compare_data.length != this.acceptlist.length){
            return true;
        } else {
            //更新前のデータを主にしてID比較した場合
            for(let i=0; this.acceptlist.length>i; i++){
                checkidA = this.compare_data.filter(item => item.t_yoyaku_id==this.acceptlist[i]["t_yoyaku_id"]);
                if(checkidA.length>0){
                    if (checkidA[0]["reception_datetime"] == this.acceptlist[i]["reception_datetime"]){
                        //処理なし
                    } else {
                        aCount++;
                    }
                } else {
                    aCount++;
                }
            }
             //更新後のデータを主にしてID比較した場合
            for(let i=0; this.compare_data.length>i; i++){
                checkidB = this.acceptlist.filter(item => item.t_yoyaku_id==this.compare_data[i]["t_yoyaku_id"]);
                if(checkidB.length>0){
                    if (checkidB[0]["reception_datetime"] == this.compare_data[i]["reception_datetime"]){
                        //処理なし
                    } else {
                        aCount++;
                    }
                }else {
                    aCount++;
                }
            }
            if(aCount>0){
                return true;
            } else {
                return false;
            }
        }
    }
    changeSoundFlg():void{
        this.adminShareService.setaccceptSetting(this.accceptSetting);
    }
    goBack(): void {
        this.location.back();
    }


    note_sound():void{
        this.base64 = SOUND_CODE;
        this.sound = new Audio(this.base64);
        this.sound.play();
    }
}



// WEBPACK FOOTER //
// ./src/app/a2105-yoyaku-accept-list/yoyaku-accept-list.component.ts